import { Navigate, useRoutes } from 'react-router-dom';

import AuthGuard from '../auth/AuthGuard';
import GuestGuard from '../auth/GuestGuard';

import CompactLayout from '../layouts/compact';
import DashboardLayout from '../layouts/dashboard';

import {
    LoginPage,
    LoginQuickPage,

    PageStart,

    PageTournamentsParticipants,
    PageTournamentsParticipant,

    //    Page500,
    //    Page403,
    Page404,


} from './elements';

export default function Router() {
    return useRoutes([
        {
            path: '/',
            element: (
                <AuthGuard>
                    <DashboardLayout />
                </AuthGuard>
            ),
            children: [
                { path: '', element: <PageStart /> },
                { path: 'login', element: (<GuestGuard><LoginPage /></GuestGuard>)},
                { path: 'login-quick', element: (<LoginQuickPage />)},

                { path: 'tournaments', children: [
                    { path: ':id/schedule/:id_schedule/participants', element: <PageTournamentsParticipants /> },
                    { path: ':id/schedule/:id_schedule/participant/:id_participant', element: <PageTournamentsParticipant /> },
                ]},

            ],
        },
        {
            element: <CompactLayout />,
            children: [{ path: '404', element: <Page404 /> }],
        },
        { path: '*', element: <Navigate to="/404" replace /> },
    ]);
}
